import { render, staticRenderFns } from "./EditPostOverview.vue?vue&type=template&id=bdd1b19c&scoped=true&"
import script from "./EditPostOverview.vue?vue&type=script&lang=ts&"
export * from "./EditPostOverview.vue?vue&type=script&lang=ts&"
import style0 from "./EditPostOverview.vue?vue&type=style&index=0&id=bdd1b19c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd1b19c",
  null
  
)

export default component.exports